import { loginWithCredentials, logout as logoutService } from '../../services/authServices';

import { validation, status } from '../../utils/constants';
import { auth } from '../../firebase';
import { replace } from '../../helpers/navigations';

const initialState = {
  fetching: false,
  status: null,
  error: null,
  message: null,
  logged: false,
  appLoadded: false,
}


// cosntants
const PREFIX = 'USER';
const FETCHING = `${PREFIX}/FETCHING`;
const FETCHING_ERROR = `${PREFIX}/FETCHING_ERROR`;
const RESET_STATE = `${PREFIX}/RESET_STATE`;
const DESTROY_STATE = `${PREFIX}/DESTROY_STATE`;

const LOGGED_VALIDATION = `${PREFIX}/LOGGED_VALIDATION`;
const LOGIN = `${PREFIX}/LOGIN`;
const LOGOUT = `${PREFIX}/LOGOUT`;

// actions
const actionFetching = status => ({ type: FETCHING, payload: status });
const actionFetchingError = (error, message, status) => ({ type: FETCHING_ERROR, payload: { error, message, status } });
const actionResetState = () => ({ type: RESET_STATE });

const actionLoggedValidation = payload => ({ type: LOGGED_VALIDATION, payload });
const actionLogin = payload => ({ type: LOGIN, payload });
const actionLogout = () => ({ type: LOGOUT });


// thunks
export const loggedValidation = () => dispatch => {
  dispatch(actionFetching(status.STATUS_LOGGED_VALIDATION));
  auth.onAuthStateChanged(user => {
    if (user) {
      dispatch(actionLoggedValidation({
        logged: true,
        email: user.email,
      }));
    }
  })
};


export const login = (email, password) => dispatch => {
  dispatch(actionFetching(status.STATUS_LOGING));
  loginWithCredentials(email, password)
    .catch(error => {
      if (error.code = 'auth/wrong-password') {
        dispatch(actionFetchingError(error, validation.WRONG_AUTH, status.STATUS_LOGING_ERROR))
      }
    })
  auth.onAuthStateChanged(user => {
    if (user) {
      dispatch(actionLoggedValidation({
        logged: true,
        appLoadded: true,
        email: user.email,
      }));
    }
  })
}

export const logout = () => async dispatch => {
  dispatch(actionFetching());
  dispatch(actionLogout());
  await logoutService();
  dispatch(actionResetState());
  replace('/');
};


// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING:
      return { ...state, fetching: true, status: action.payload || status.STATUS_FETCHING };
    case FETCHING_ERROR:
      return {
        ...state, fetching: false, status: action.payload.status || status.DEFAULT_FETCHING_ERROR,
        error: action.payload.error || validation.DEFAULT_ERROR,
        message: action.payload.message || validation.DEFAULT_ERROR_MESSAGE,
      };
    case RESET_STATE:
      return { ...state, fetching: false, status: null, error: null, message: null };

    case LOGGED_VALIDATION:
      return { ...state, ...action.payload, appLoadded: true, };
    case LOGIN:
      return { ...state, ...action.payload };

    case LOGOUT:
      return { ...initialState, appLoadded: true };
  
    default:
      return state;
  }
}
